export default "assets/images/arrow-a81d9c1a.png";